module.exports = __webpack_public_path__ + "static/media/Arrow-Right.fed5958c.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/Arrow-Right.PNG
// module id = 1640
// module chunks = 1